import navbarData from '@/data/docs/navbar.json';
import { NavbarDropdownData } from '@/store/navigation/types';

export const navbarNavData: NavbarDropdownData[] = Object.values(navbarData);
